import { baseState, baseMutations } from '@/store/mixins'
import home from '@/api/project-mgt/home'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  getTask(context) {
    return home.getTask()
  }
}
